









































































































































import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';

import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';

import api from '@/libs/api';
import numberFormat from '@/libs/numberFormat';

@Component({
  components: {
    LayoutContent,
    FormInput,
  },
  methods: {
    numberFormat,
  },
})

export default class ExternalDetailTraffic extends Vue {
  /* eslint-disable */
  numberFormat!: typeof numberFormat;

  trafficPerDay: any[] = [];

  get isSinglePeriod() {
    try {
      if (this.selectedPeriod.length === 1) {
        if (this.selectedPeriod[0].merchant_traffic.length === 1) {
          return true;
        }
      }
      return false;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  cancelChange() {
    try {
      console.log(this.trafficPerDay);
      this.trafficPerDay.forEach((data: any) => {
        data.merchant_amount = data.amount;
      })
    } catch (error) {
      console.log(error);
    }
  }

  hitungDetail(type: string, itemData: any) {
    try {
      const price: any = this.selectedPeriod[0].price_per_transaction;
      const listPrice: any[] = price.split(",");
      switch (type) {
        case "mdr_fee": {
          return parseFloat(itemData.merchant_amount || 0) * parseFloat(listPrice[1] || 0);
        }
        case "normal_fee": {
          return parseInt(itemData.merchant_traffic || 0) * parseFloat(listPrice[0] || 0);
        }
        case "billing_total": {
          return (parseFloat(itemData.merchant_amount || 0) * parseFloat(listPrice[1] || 0)) +
            (parseInt(itemData.merchant_traffic || 0) * parseFloat(listPrice[0] || 0));
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  hitungTotal(type: string, merchant_traffic: any[] = []) {
    try {
      let total = 0;
      switch (type) {
        case "sprint": {
          if (this.trafficPerDay) {
            this.trafficPerDay.forEach((data: any) => {
              total += parseInt(data.traffic || 0);
            })
          }
          break;
        }
        case "merchant": {
          if (this.trafficPerDay) {
            this.trafficPerDay.forEach((data: any) => {
              total += parseInt(data.merchant_traffic || 0);
            })
          }
          break;
        }
        case "difference": {
          if (this.trafficPerDay) {
            this.trafficPerDay.forEach((data: any) => {
              total += (parseInt(data.traffic || 0) - parseInt(data.merchant_traffic || 0));
            })
          }
          break;
        }
        case "merchant_amount": {
          if (this.trafficPerDay) {
            this.trafficPerDay.forEach((data: any) => {
              total += parseFloat(data.merchant_amount || 0);
            })
          }
          break;
        }
        case "multiple": {
          merchant_traffic.forEach((data: any) => {
            total += parseInt(data.total_traffic || 0);
          })
          break;
        }
        case "mdr_fee":
        case "normal_fee":
        case "billing_total": {
          if (this.trafficPerDay) {
            this.trafficPerDay.forEach((data: any) => {
              total += this.hitungDetail(type, data) || 0;
            })
          }
          break;
        }
      }
      return total;
    } catch (error) {
      console.log(error);
      return 0;
    }
  }

  viewDetail(item: any, item2: any) {
    let selectedDetail: any = {
      item,
      item2
    }
    this.$emit('viewDetailClick', selectedDetail);
  }

  getBillType(itemData: any) {
    try {
      return itemData.merchant_traffic[0].price_type;
    } catch (error) {
      console.log(error);
      return '';
    }
  }

  isDifferent(itemData: any) {
    try {
      if (/fix|tiring/.test(this.getBillType(itemData))) {
        return (parseInt(itemData.traffic || 0) - parseInt(itemData.merchant_traffic || 0)) !== 0
      } else {
        return (parseInt(itemData.traffic || 0) - parseInt(itemData.merchant_traffic || 0)) !== 0 ||
          (parseInt(itemData.amount || 0) - parseInt(itemData.merchant_amount || 0)) !== 0
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  @Prop() readonly merchantDisclaim!: boolean;
  @Prop() readonly selectedPeriod!: any[];

  @Watch('selectedPeriod')
  async selectedPeriodChange() {
    if (this.isSinglePeriod) {
      const selectedPeriod = this.selectedPeriod[0];
      const { data } = await api.get(`recon/external/billing/${selectedPeriod.merchant_traffic[0].id}`);
      if (data.data) {
        this.trafficPerDay = data.data.list;
      }
    }
  }

  @Watch('trafficPerDay')
  trafficPerDayChanged() {
    this.$emit('trafficPerDayChanged', this.trafficPerDay);
  }
}
